import React from 'react';
import CircularProgress from "@material-ui/core/CircularProgress";

export default function Loader(){
    return <div className="circular-wrapper" style={{width:"100%",height:"100%"}}><CircularProgress style={{color:"rgb(57, 187, 15)"}}/></div>
}